/**
 * Provider for customBehavior ("custom behavioral attributes" or "computed attributes")
 *
 * @module
 */
var _ = require('optimizely-client-fn');
var BehaviorAttributes = require('../../helpers/behavior_attributes');
var eventsHelper = require('../../helpers/events');
var JSONEnv = require('core/lib/json');
var ruleBuilder = require('../../helpers/rule_builder');

module.exports = {
  provides: 'customBehavior',
  shouldTrack: true,

  // Note(tyler): Only events up to the previous activation will be used. This could potentially
  // be changed if we decide it's not too expensive.
  isLazy: false,

  getter: [
    'stores/global',
    'stores/visitor_attribute_entity',
    /**
     * @param {Store} GlobalStore
     * @param {Store} VisitorAttributeEntityStore
     * @returns {Object.<*>} Mapping from custom behavioral attribute IDs to values.
     */
    function(GlobalStore, VisitorAttributeEntityStore) {
      var projectId = GlobalStore.getProjectId();
      var customBehavioralAttributes = _.filter(_.map(
        VisitorAttributeEntityStore.getCustomBehavioralAttributes(projectId),
        function(attribute) {
          try {
            return {
              id: attribute.id,
              granularity: BehaviorAttributes.GRANULARITY.ALL,
              rule: ruleBuilder.buildFromSpecV0_2(JSONEnv.parse(attribute.rule_json))
              // TODO: Specify defaultValue?
            };
          } catch (e) {
            // TODO: Have validateSpecV0_2 throw a specific type of error, then catch only that type of error
            // (plug JSON SyntaxError) here.
            return;
          }
        }
      ));
      var events = eventsHelper.getEvents();
      return BehaviorAttributes.evaluate(customBehavioralAttributes, events);
    }
  ],
};
